/** Longitud exacta del VIN */
export const VIN_LENGTH = 17;

/** Regex: 17 caracteres alfanuméricos sin I, O, Q */
const VIN_VALID_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/;

/**
 * Indica si el valor es un VIN válido (17 caracteres, sin I, O, Q).
 */
export function isValidVin(value: string): boolean {
  if (!value || value.length !== VIN_LENGTH) return false;
  return VIN_VALID_REGEX.test(value.toUpperCase());
}

/**
 * Sanitiza input VIN: mayúsculas, solo caracteres permitidos (sin I, O, Q), máx 17.
 */
export function sanitizeVinInput(value: string): string {
  return value
    .toUpperCase()
    .replace(/[^A-HJ-NPR-Z0-9]/g, '')
    .slice(0, VIN_LENGTH);
}

export const VIN_ERROR_MESSAGE =
  'El VIN debe tener 17 caracteres alfanuméricos (sin I, O, Q).';
